import React, { useState, useEffect, useRef, useMemo } from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
// import { usePlacesWidget } from "react-google-autocomplete";
import { loadStates } from "../../_redux/actions/userActions";
import { USA, Australia } from "@/_helpers/CountryConstants";
// import { goTo } from "@/_helpers/navigation";
import {
  updateEnrollee,
  clientUpdate,
} from "../../_redux/actions/enrolleeActions";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import HomeIcon from "@mui/icons-material/Home";
import { brandColors } from "../../_components/brandedComponent/BrandedColors";
import { LifeSafer } from "../../_helpers/BrandConstants";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import { useTheme } from "@mui/material/styles";
import ContinueButton from "./ContinueButton";
import GooglePlaceAutocomplete from "../GooglePlaceAutocomplete";
import { utilities } from "@/_helpers";

const AddressInfo = ({
  // enrollee,
  // updateEnrollee,
  // clientUpdate,
  statesList,
  loadStates,
  goToBackStep,
  submitting,
  handleUpdate,
}) => {
  const cookies = new Cookies();
  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const siteCountryId = cookies.get("siteCountry") || USA;
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  // const deviceType = localStorage.getItem("devicetype");
  const isMountedRef = useRef(null);
  // const [addressCountry, setAddressCountry] = useState("us");
  const [addressLine1, setAddressLine1] = useState(
    enrolleeUser?.homeAddr1 ? enrolleeUser?.homeAddr1 : "",
  );
  // const [addrLine1Error, setAddrLine1Error] = useState(false);
  // const [addrLine1ErrorMessage, setAddrLine1ErrorMessage] = useState("");
  const [googleValid, setGoogleValid] = useState(false);
  // const [submitting, setSubmitting] = useState("false");
  // const [localDisable, setLocalDisable] = useState(false);
  const [zipLength, setZipLength] = useState(5);
  const { t } = useTranslation();
  // const theme = useTheme();
  const [city, setCity] = useState("");
  const [county, setCounty] = useState("");
  const [stateShortName, seStateShortName] = useState("");
  // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [latLngValue, setLatLngValue] = useState({
    lat: 0,
    lng: 0,
  });

  const findState = (shortName) => {
    let retState = enrolleeUser?.state || "";
    let stateInfo = statesList.filter((x) => x.shortName === shortName);
    if (stateInfo[0] !== undefined) {
      retState = stateInfo[0].name;
    }
    return retState;
  };

  useEffect(() => {
    isMountedRef.current = true;
    if (isMountedRef.current && enrolleeUser !== undefined) {
      if (enrolleeUser?.homeAddr1) {
        clearErrors("homeAddr1");
        setGoogleValid(true);
      }
      if (enrolleeUser?.city && enrolleeUser?.county && enrolleeUser?.state) {
        clearErrors("CCS");
        setGoogleValid(true);
      }
    }
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const getCCS = useMemo(() => {
    if (!statesList || statesList.length === 0) return "";
    const city = enrolleeUser?.city ?? "";
    const county = enrolleeUser?.county ?? "";
    const state = enrolleeUser?.state ?? "";

    // const parts = [];
    // if (city.trim()) parts.push(city);
    // if (county.trim()) parts.push(county);
    // if (state.trim()) parts.push(findState(state));

    // return parts.length ? parts.join(", ") : "";

    if(!city && !county && !state)
    {
      return "";
    }


    
  return `${city.trim()}, ${county.trim()}, ${findState(state)?.trim() ?? ""}`;

  }, [statesList, enrolleeUser]);

  useEffect(() => {
    if (getCCS) {
      setValue("CCS", cleanValue(getCCS));
    }
  }, [getCCS, setValue]);

const cleanValue = (v) => {
  return (v ?? "")
    .split(",")
    .map(s => s.trim())
    .filter(Boolean)
    .join(", ");
};

  const {
    register,
    handleSubmit,
    // reset,
    clearErrors,
    setValue,
    control,
    setError,
    getValues,
    formState: { errors },
    watch,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      homeAddr1: enrolleeUser?.homeAddr1 ?? "",
      homeAddr2: enrolleeUser?.homeAddr2 ?? "",
      CCS: "",
      zip: enrolleeUser?.zip ?? "",
    },
  });

  const homeAddr1 = watch("homeAddr1");

  // const { ref: materialRef } = usePlacesWidget({
  //   apiKey: process.env.REACT_APP_GOOGLE_KEY,
  //   onPlaceSelected: (place) => updateInputBoxes(place),
  //   options: {
  //     types: ["geocode"],
  //     componentRestrictions: { country: addressCountry },
  //   },
  //   inputAutocompleteValue: "addressLine1",
  // });

  const updateInputBoxes = (data) => {
    let address = data?.formatted_address || "";
    const addressComponents = utilities.normalizeAddressComponents(
      data.address_components,
    );

    const getAddressComponent = (type) =>
      addressComponents.find((component) => component.types.includes(type))
        ?.long_name || "";
    const streetNumber = getAddressComponent("street_number");
    const premise = getAddressComponent("premise");
    const route = getAddressComponent("route");
    const formattedAddressLine1 = address.split(",")[0]?.trim() || "";
    const addressLine1WithStreetNumber =
      [streetNumber || premise, route].filter(Boolean).join(" ").trim() ||
      formattedAddressLine1;

    let cityIndex = addressComponents.findIndex((x) =>
      x.types.find((e) => e === "locality"),
    );
    let countyIndex = addressComponents.findIndex((x) =>
      x.types.find((e) => e === "administrative_area_level_2"),
    );
    let stateIndex = addressComponents.findIndex((x) =>
      x.types.find((e) => e === "administrative_area_level_1"),
    );
    let zipIndex = addressComponents.findIndex((x) =>
      x.types.find((e) => e === "postal_code"),
    );
    // let countryIndex = addressComponents.findIndex((x) =>
    //   x.types.find((e) => e === "country"),
    // );

    if (data?.geometry?.location) {
      let latData = data?.geometry?.location?.lat();
      let lngData = data?.geometry?.location?.lng();

      setLatLngValue({ lat: latData, lng: lngData });
    }

    let derivedCity =
      cityIndex === -1 ? "" : addressComponents[cityIndex].long_name;
    let derivedCounty =
      countyIndex === -1 && cityIndex === -1
        ? ""
        : addressComponents[countyIndex === -1 ? cityIndex : countyIndex]
            .long_name;
    let derivedState =
      stateIndex === -1 ? "" : addressComponents[stateIndex].short_name;
    // let derivedCountry =
    //   countryIndex === -1 ? "USA" : addressComponents[countryIndex].short_name;
    // derivedCountry = utilities.normalizeCountryForPlus(derivedCountry, "USA");
    let derivedZip =
      zipIndex === -1 ? "" : addressComponents[zipIndex].short_name;

    // let updatedData = {
    //   homeAddr1: address.substr(0, address.indexOf(",")),
    //   city: derivedCity,
    //   county: derivedCounty,
    //   state: derivedState,
    //   country: derivedCountry,
    //   zip: derivedZip,
    //   homeLat: data?.geometry?.location?.lat(),
    //   homeLong: data?.geometry?.location?.lng(),
    // };
    // let updatedEnrolleeObj = { ...enrollee, ...updatedData };
    // updateEnrollee(updatedEnrolleeObj);
    setValue("homeAddr1", addressLine1WithStreetNumber, {
      shouldValidate: true,
      shouldDirty: true,
    });

    setCity(derivedCity ?? "");
    setCounty(derivedCounty ?? "");
    seStateShortName(derivedState ?? "");
    setAddressLine1(addressLine1WithStreetNumber);
    // setAddrLine1Error(false);
    // setAddrLine1ErrorMessage("None");
    setGoogleValid(true);
    clearErrors("homeAddr1");

    
    // comment for now
    // reset({
    //   CCS: derivedCity + ", " + derivedCounty + ", " + derivedState,
    //   zip: derivedZip,
    // });
    // setValue("CCS", `${derivedCity} , ${derivedCounty}, ${derivedState}`, {
    //   shouldValidate: true,
    //   shouldDirty: true,
    // });

    const ccsValue = [derivedCity, derivedCounty, findState(derivedState)]
      .map((item) => item?.trim())
      .filter(Boolean)
      .join(", ");

    setValue("CCS", ccsValue, {
      shouldValidate: true,
      shouldDirty: true,
    });

    setValue("zip", derivedZip, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  // const validateCityCountyState = (value) => {
  //   if (value) {
  //     const parts = value?.split(",");
  //     const city = parts[0]?.trim();
  //     const county = parts[1]?.trim();
  //     const state = parts[2]?.trim();
  //     if (!city) {
  //       return t("body.cCCityRequired");
  //     } else if (!county) {
  //       return t("body.cCCountyRequired");
  //     } else if (!state) {
  //       return t("body.cCStateRequired");
  //     } else {
  //       return true;
  //     }
  //   }
  // };
  const validateCityCountyState = (value) => {


    if (!value || !value.trim()) {
      return t("steps.stateCityCountyRequired");
    }


    const parts = value.split(",");
    const city = parts[0]?.trim();
    const county = parts[1]?.trim();
    const state = parts[2]?.trim();

    if (city && county && state) return true;

    const missingFields = [];
    if (!city) missingFields.push("City");
    if (!county) missingFields.push("County");
    if (!state) missingFields.push("State");

    return t("steps.addressRequired", {
      addressRequired: `${missingFields.join(", ")} is required`,
    });
  };

  // will be used later
//   const getDisplayCCS = useMemo(() => {
//   // if (!statesList || statesList.length === 0) return "";
//   // // console.log("ccc 11",city)
//   // const displayCity =city  ?? enrolleeUser?.city ?? "";
//   // const displayCounty = county??enrolleeUser?.county??"";
//   // const displayState =stateShortName ??  enrolleeUser?.state ?? "";


//   //   console.log(displayCity,displayCounty,displayState)

//   //   console.log(enrolleeUser)


//   // return [displayCity, displayCounty,findState(displayState)]
//   //   .map(p => p?.trim() ?? "")
//   //   .filter(Boolean)
//   //   .join(", ");

// }, [statesList, enrolleeUser,city,county,stateShortName]);


const getDisplayCCS = useMemo(() => {
  // if (!statesList || statesList.length === 0) return "";
  // // console.log("ccc 11",city)
  // const displayCity =city  ?? enrolleeUser?.city ?? "";
  // const displayCounty = county??enrolleeUser?.county??"";
  // const displayState =stateShortName ??  enrolleeUser?.state ?? "";


  //   console.log(displayCity,displayCounty,displayState)

  //   console.log(enrolleeUser)


  // return [displayCity, displayCounty,findState(displayState)]
  //   .map(p => p?.trim() ?? "")
  //   .filter(Boolean)
  //   .join(", ");
  

}, [statesList, enrolleeUser,city,county,stateShortName]);

  const onSubmit = (data) => {
    const address1 = addressLine1?.trim();
    const homeAddress1 = data.homeAddr1?.trim();
    const CCS = data.CCS?.trim();
    if (!address1 && !homeAddress1) {
      setError("homeAddr1", {
        type: "manual",
        message: t("body.homeAddrRequired"),
      });
      return;
    }
    if (!CCS) {
      setError("CCS", {
        type: "manual",
        message: t("body.cCStateRequired"),
      });
      return;
    }

    let oldData = {
      EnrolleeId: enrolleeUser?.enrolleeId,
      ClientId: enrolleeUser?.clientId,
      UserId: enrolleeUser?.userId,
      firstName: enrolleeUser?.firstName,
      lastName: enrolleeUser?.lastName,
      dob: enrolleeUser?.dob,
      country: enrolleeUser?.country,
      dlState: enrolleeUser?.dlState || null,
      dlNum: enrolleeUser?.dlNum || "CE - NEED",
      dlExpirationDate: enrolleeUser?.dlExpirationDate,
      email: enrolleeUser?.email,
      homePhone: enrolleeUser?.homePhone,
      cellPhone: enrolleeUser?.cellPhone,
      workPhone: enrolleeUser?.workPhone,
      programType: enrolleeUser?.programType,
      protPlan: enrolleeUser?.protPlan,
      contractEnd: enrolleeUser?.contractEnd,
      enrollmentCode:
        enrolleeUser?.enrollmentCode || enrolleeUser?.EnrollmentCode,
      enrollmentCodeId:
        enrolleeUser?.enrollmentCodeId ||
        enrolleeUser?.EnrollmentCodeId ||
        enrolleeUser?.EnrollmentCodeID,
      deviceType: enrolleeUser?.deviceType,
    };

    // 1. Do we have an Address?
    if (addressLine1.length > 0) {
      // 2. Do we have a City, County, State?
      if (googleValid) {
        let newData = {
          homeAddr1: addressLine1 || enrolleeUser?.homeAddr1,
          homeAddr2: data.homeAddr2,
          country: "USA",
          city: city || enrolleeUser?.city,
          county: county || enrolleeUser?.county,
          state: stateShortName || enrolleeUser?.state,
          zip: data.zip,
          homeLat: latLngValue?.lat || enrolleeUser?.homeLat,
          homeLong: latLngValue?.lng || enrolleeUser?.homeLong,
          Step: "Address",
        };
        let updatedData = {
          ...oldData,
          ...newData,
        };
        handleUpdate("Address", updatedData);
      } else {
        // setAddrLine1Error(true);
        // setAddrLine1ErrorMessage("Directions");
      }
    } else {
      // setAddrLine1Error(true);
      // setAddrLine1ErrorMessage("Required");
      setGoogleValid(false);
    }
  };

  useEffect(() => {
    // if (materialRef.current !== null) setLocalDisable(false);
    isMountedRef.current = true;
    if (isMountedRef.current) {
      if (
        statesList === undefined ||
        statesList[0].CurrentState === "Undefined"
      ) {
        loadStates(siteCountryId, brand).catch((error) => {
          console.log("Loading violation dashboard failed! " + error);
        });
      }
      if (siteCountryId === Australia) {
        // setAddressCountry("au");
        setZipLength(4);
      }
    }

    return () => (isMountedRef.current = false);
  }, []);

  // useEffect(() => {
  //   if (materialRef.current !== null) setLocalDisable(false);
  // }, [materialRef]);

  const onError = () => {
    const ccs = getValues("CCS");
    validateCityCountyState(ccs);
  };

  return (
    <>
      <div>
        <form
          className="form"
          onSubmit={handleSubmit(onSubmit, onError)}
          // style={{
          //   marginTop: 0,
          // }}
          style={{
            width: "100%",
            marginBottom: "40px",
            display: "flex",
            justifyContent: "center",
            maxWidth: "900px",
          }}
        >
          <Grid
            container
            justifyContent="center"
            alignItems="start"
            sx={{
              width: "100%",
              marginTop: "25px",
            }}
            spacing="25px"
          >
            <Grid style={{ maxWidth: "300px", width: "100%" }}>
              {/* <Controller
              name="homeAddr1"
              control={control}
              rules={{
                required: { value: false, message: t("body.homeAddrRequired") },
              }}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  size="small"
                  style={{ maxWidth: "300px", width: "100%" }}
                  id="homeAddr1"
                  label={t("body.homeAddr1Label")}
                  autoFocus
                  disabled={localDisable || submitting}
                  placeholder={t("body.enterHomeAddress")}
                  error={!!fieldState.error || addrLine1Error}
                  helperText={
                    !fieldState.error || addrLine1Error
                      ? addrLine1ErrorMessage === "Required"
                        ? t("body.homeAddrRequired")
                        : addrLine1ErrorMessage === "Directions"
                        ? t("body.homeAddrDirections")
                        : ""
                      : fieldState.error?.message || t("body.homeAddrRequired")
                  }
                  inputRef={materialRef}
                  value={addressLine1}
                  onChange={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    setAddressLine1(value);

                    if (value.length > 0 && googleValid === true) {
                      setAddrLine1Error(false);
                      setAddrLine1ErrorMessage("None");
                    } else {
                      setAddrLine1Error(true);
                      setAddrLine1ErrorMessage(
                        googleValid === true ? "Required" : "Directions"
                      );
                    }
                    clearErrors("homeAddr1");
                  }}
                  InputProps={{
                    startAdornment: (
                      <HomeIcon
                        className="inputIco"
                        style={{ color: brandColors[brand].primary }}
                      />
                    ),
                  }}
                />
              )}
            /> */}

              {/* <GooglePlaceAutocomplete
                name="homeAddr1"
                control={control}
                label={t("body.homeAddr1Label")}
                startIcon={HomeIcon}
                countryCodes="US"
                onPlaceSelected={updateInputBoxes}
                // defaultValue={enrolleeUser?.homeAddr1}
                // value={address1}
                errors={errors}
                required={true}
                size="small"
                placeholder={t("body.enterHomeAddress")}
                startIconClassName="inputIco"
              /> */}

              <GooglePlaceAutocomplete
                name="homeAddr1"
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: t("body.homeAddrRequired"),
                  },
                  validate: (value) =>
                    value && value.trim().length > 0
                      ? true
                      : t("body.homeAddrRequired"),
                }}
                label={t("body.homeAddr1Label")}
                startIcon={HomeIcon}
                size="small"
                startIconClassName="inputIco"
                startIconColor={brandColors[brand].primary}
                countryCodes="US"
                onPlaceSelected={updateInputBoxes}
                defaultValue={enrolleeUser?.homeAddr1}
                errors={errors}
                value={homeAddr1}
                placeholder={t("body.enterHomeAddress")}
                // manualMode={isChecked}
                onChange={(value) =>
                  setValue("homeAddr1", value, {
                    shouldDirty: true,
                    shouldValidate: true,
                  })
                }
              />
            </Grid>
            <Grid style={{ maxWidth: "300px", width: "100%" }}>
              <TextField
                variant="outlined"
                size="small"
                id="homeAddr2"
                label={t("body.homeAddr2Label")}
                name="homeAddr2"
                disabled={submitting}
                error={!!errors.homeAddr2}
                style={{ maxWidth: 300, width: "100%" }}
                helperText={errors.homeAddr2 ? errors.homeAddr2.message : ""}
                {...register("homeAddr2", { minLength: 0 })}
                InputProps={{
                  startAdornment: (
                    <HomeIcon
                      className="inputIco"
                      style={{ color: brandColors[brand].primary }}
                    />
                  ),
                }}
              />
            </Grid>
            <Grid style={{ maxWidth: "300px", width: "100%" }}>
              <TextField
                variant="outlined"
                size="small"
                //   fullWidth
                disabled
                id="CCS"
                label={t("body.ccsLabel")}
                placeholder={t("body.ccsPlaceholder")}
                helperText={errors.CCS ? errors.CCS.message : ""}
                error={!!errors.CCS}
                name="CCS"
                style={{ maxWidth: 300, width: "100%" }}
                {...register("CCS", {
                  required: {
                    value: true,
                    message: t("steps.stateCityCountyRequired"),
                  },
                  validate: validateCityCountyState,
                })}
                  inputProps={{
    value: getDisplayCCS,
  }}
                InputProps={{
                  startAdornment: (
                    <HomeIcon
                      className="inputIco"
                      style={{ color: brandColors[brand].primary }}
                    />
                  ),
                }}
              />
            </Grid>
            <Grid style={{ maxWidth: "300px", width: "100%" }}>
              <TextField
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, zipLength);
                }}
                variant="outlined"
                //margin="dense"
                size="small"
                //   fullWidth
                id="zip"
                label={t("payments.zipCode")}
                name="zip"
                style={{ maxWidth: 300, width: "100%" }}
                disabled={submitting}
                error={!!errors.zip}
                helperText={errors.zip ? errors.zip.message : ""}
                {...register("zip", {
                  required: { value: true, message: t("body.zipRequired") },
                  validate: (value) => {
                    if (value.replace(/\D/g, "").length >= zipLength) {
                      return true;
                    } else {
                      return t("body.zipValid");
                    }
                  },
                })}
                InputProps={{
                  startAdornment: (
                    <HomeIcon
                      className="inputIco"
                      style={{ color: brandColors[brand].primary }}
                    />
                  ),
                }}
              />
            </Grid>

            <Grid style={{ width: "100%" }}>
              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  // mt: "25px",
                }}
              >
                <Grid style={{ width: "100%" }}>
                  <Grid
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      mt: "25px",
                    }}
                  >
                    <ContinueButton
                      goToBackStep={goToBackStep}
                      submitting={submitting}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </div>
    </>
  );
};

AddressInfo.propTypes = {
  actionProvider: PropTypes.object.isRequired,
  enrollee: PropTypes.object.isRequired,
  updateEnrollee: PropTypes.func,
  onChange: PropTypes.func,
  statesList: PropTypes.array,
  loadStates: PropTypes.func,
  handleUpdate: PropTypes.func,
  goToBackStep: PropTypes.func,
  submitting: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    enrollee: state.enrollee,
    statesList: state.statesList,
  };
}

const mapDispatchToProps = {
  updateEnrollee,
  clientUpdate,
  loadStates,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressInfo);
